<template>
    <div class="buy">
        <el-dialog :append-to-body="true" class="buy-dialog" width="662px" :visible.sync="dialogVisible"
            @close="cancelVisible">
            <div :class="[activeType == 1 ? 'buy-bg1' : 'buy-bg']">
                <div class="title">购买详情</div>
                <div :class="[activeType == 1 ? 'buy-detail1' : 'buy-detail']">
                    <div>
                        <div class="money">
                            <div class="m-title">实付金额：</div>
                            <div class="m-num"><span style="font-size: 12px;">￥</span>{{ price }}</div>
                        </div>
                        <div class="buy-type">

                            <a style="cursor:pointer" @click="setType(index)"
                                :class="[activeType == index ? 'buy-type-item-active' : 'buy-type-item']"
                                v-for="(item, index) in typeList" :key="index">
                                <img :src="item.url" />
                                <span>{{ item.label }}</span>
                                <div v-if="activeType == index" :class="[index != 0 ? 'select-sign' : 'select-sign2']">
                                    <i class="el-icon-check" style="color: #fff;"></i>
                                </div>
                            </a>

                        </div>
                    </div>


                    <div v-if="activeType == 0" class="buy-describe">
                        <div class="buy-type-code">
                            <div id="qrcode" ref="qrcode"></div>
                        </div>
                        <div class="buy-tips">
                            <img src="../assets/icon/icon-s-code.png" />
                            <span>打开手机微信扫码继续支付</span>
                        </div>
                    </div>
                    <div v-else class="buy-describe2">
                        <div class="flex justify-between align-center buy-margin-12">
                            <div>
                                <div class="buy-duigong-text1">使用对公转账需注意以下信息！</div>
                                <div class="buy-duigong-text2" style="margin: 12px 0;">第一步：请扫码或致电客服，确认购买报告信息。</div>
                                <div class="buy-duigong-text3">客服电话：16678505051</div>
                            </div>
                            <img class="buy-kefu-code" src="https://s.ryqxdata.com/bigdata/img/serviceCode.jpg" />
                        </div>
                        <div class="buy-duigong-text2" style="margin-top: 14px;">第二步: 将实付金额汇入专属账号后，请再次联系客服，获取报告。</div>
                        <div style="margin-top: 24px;">
                            <span class="buy-duigong-text1">本订单专属汇款账号如下：</span>
                            <el-button type="text" @click="onCopy" class="buy-duigong-text4">一键复制汇款信息</el-button>
                            <!-- <a style="cursor:pointer" @click="onCopy" class="buy-duigong-text4">一键复制汇款信息</a> -->
                        </div>
                        <div class="buy-duigong-text5 buy-margin-12">请通过企业对公账户完成转账，不接受个人账号汇款</div>
                        <div class="buy-duigong-text5 buy-margin-12">开户名称： 青岛千禧大数据信息产业有限公司</div>
                        <div class="buy-duigong-text5 buy-margin-12">开户银行： 青岛农村商业银行股份有限公司黄岛珠江路支行</div>
                        <div class="buy-duigong-text5 buy-margin-12 flex align-center">
                            <span>汇款账号：</span>
                            <div>2060 0050 5420 5000 010 798</div>
                        </div>
                        <div class="buy-duigong-text6 buy-margin-12">请确保一次性完成汇款(汇款金额=订单金额)，不支持多次汇款</div>
                    </div>

                </div>
            </div>

        </el-dialog>
    </div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
    inject: ['reload'],
    data() {
        return {
            dialogVisible: false,
            activeType: 0,
            typeList: [{
                label: '微信支付',
                url: 'https://s.ryqxdata.com/bigdata/img/icon-weixin.png'
            }, {
                label: '对公转账',
                url: 'https://s.ryqxdata.com/bigdata/img/icon-duigong.png'
            }],
            text: '开户名称： 青岛千禧大数据信息产业有限公司;开户银行： 青岛农村商业银行股份有限公司黄岛珠江路支行;汇款账号：2060 0050 5420 5000 010 798',
            price: 0,
            formData: {
                type: 2,
                userId: '',
                reportId: '',
                reportType: 1,
                description: '',
                price: '',
            },
            codeInfo: null,
            myTarget: null
        };
    },
    methods: {
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        },
        setType(index) {
            this.activeType = index
            if (this.activeType == 0) {
                this.getWxCode(this.formData)
            } else {
                clearInterval(this.myTarget);
            }
        },
        onCopy() {
            this.$copyText(this.text).then(e => {
                this.$message({
                    message: '复制成功',
                    type: 'success'
                });
                console.log('复制成功：', e);
            }, e => {
                this.$message({
                    message: '复制失败',
                    type: 'error'
                });
                console.log('复制失败：', e);
            })
        },
        setVisible(data) {
            this.dialogVisible = data.status
            this.price = data.price
            this.formData.userId = data.userId
            this.formData.reportId = data.reportId
            this.formData.reportType = data.reportType
            this.formData.description = data.description
            this.formData.price = data.price
            this.getWxCode(this.formData)
        }, 
        getWxCode(data) {
            let that = this
            this.apis.wxQrCode(data).then((res) => {
                that.codeInfo = res.data
                that.getCoed(this.codeInfo.url)
                that.myTarget = setInterval(() => {
                    //需要定时执行的代码
                    that.apis.wxOrderPayStatus({ orderNo: res.data.orderNo, type: res.data.type }).then((re) => {
                        if (re.code == 0) {
                            if (re.data.isPayed == 1) {
                                clearInterval(that.myTarget);
                                that.$message({
                                    message: '支付成功！',
                                    type: 'success'
                                });
                                that.reload()
                            }
                        } else {
                            clearInterval(that.myTarget);
                        }
                    })
                }, 3000)
            })
        },
        getCoed(url) {
            new QRCode(('qrcode'), {
                width: 221, // 二维码宽度 
                height: 221, // 二维码高度
                text: url, // 浏览器地址url
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H,
            })

        },
        cancelVisible() {
            this.dialogVisible = false
            clearInterval(this.myTarget);
            this.$refs.qrcode.innerHTML = ''
        },
    }
};
</script>
<style>
.buy-bg {
    background-image: url('../assets/images/payment-bg.png');
    width: 662px;
    height: 458px;
    border-radius: 6px;
}

.buy-bg1 {
    background-image: url('../assets/images/payment-bg-1.png');
    width: 662px;
    height: 516px;
    border-radius: 6px;
}

.buy-dialog .el-dialog {
    border-radius: 6px;
}

.buy-dialog .el-dialog__body {
    padding: 0;

}

.buy-dialog .el-dialog__header {
    padding: 0;
}

.buy-dialog .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
}

.buy-dialog .title {
    font-size: 24px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 28px;
    text-align: center;
    padding: 22px 0 24px 0;
}

.buy-dialog .buy-detail {
    width: 598px;
    height: 346px;
    background: #FFFFFF;
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
    margin: 0 auto;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
}

.buy-dialog .buy-detail1 {
    width: 598px;
    height: 404px;
    background: #FFFFFF;
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
    margin: 0 auto;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
}

.buy-dialog .money {
    width: 200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 14px;
}

.m-title {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 16px;
}

.m-num {
    font-size: 24px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #E74B4B;
    line-height: 28px;
}

.buy-type-content {
    margin-top: 14px;
    display: flex;
    justify-content: space-between;
}

.buy-type {
    border-radius: 6px;
    margin-top: 14px;

}

.buy-type .buy-type-item-active {
    width: 200px;
    height: 56px;
    background: #E7F2FC;
    opacity: 1;
    border: 1px solid #4189E5;
    display: flex;
    align-items: center;
    position: relative;
}

.buy-type .buy-type-item {
    width: 200px;
    height: 56px;
    background: #FFFFFF;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 1px solid #BEC2C7;
    display: flex;
    align-items: center;
    position: relative;
}

.buy-type .buy-type-item:first-child,
.buy-type .buy-type-item-active:first-child {
    border-radius: 12px 12px 0 0;
}

.buy-type .buy-type-item:last-child,
.buy-type .buy-type-item-active:last-child {
    border-radius: 0 0 12px 12px;
}

.buy-type .buy-type-item img,
.buy-type .buy-type-item-active img {
    margin-left: 18px;
    width: 27px;
    height: 27px;
}

.buy-type .buy-type-item span,
.buy-type .buy-type-item-active span {
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #242627;
    line-height: 19px;
    margin-left: 7px;
}

.select-sign,
.select-sign2 {
    width: 24px;
    height: 24px;
    background: #4189E5;
    opacity: 1;
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;

}

.select-sign {
    border-radius: 0 0 0 6px;
}

.select-sign2 {
    border-radius: 0 6px 0 6px;
}

.buy-describe {
    margin-top: 22px;
}

.buy-type-code {
    width: 240px;
    height: 240px;
    background: #FFFFFF;
    opacity: 1;
    border: 1px solid #F5F6F6;
    border-radius: 6px 6px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.buy-type-code img {
    width: 221px;
    height: 221px;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
}

.buy-tips {
    width: 240px;
    height: 60px;
    background: #F7F6F6;
    opacity: 1;
    border-radius: 0 0 6px 6px;
    display: flex;
    align-items: center;
}

.buy-tips img {
    width: 31px;
    height: 32px;
    margin-left: 32px;
}

.buy-tips span {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 500;
    color: #242627;
    line-height: 16px;
    margin-left: 12px;
    margin-right: 32px;
}

.buy-kefu-code {
    width: 114px;
    height: 114px;
    margin-left: 5px;
    border: 1px solid #F5F6F6;
    border-radius: 6px;
}

.buy-describe2 {
    margin-left: 24px;
}

.buy-duigong-text1 {
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #242627;
    line-height: 16px;
}

.buy-duigong-text2 {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #306EFF;
    line-height: 16px;
}

.buy-duigong-text3 {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #242627;
    line-height: 16px;
}

.buy-duigong-text4 {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #4189E5;
    line-height: 16px;
    height: 16px;
}

.buy-duigong-text5 {
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #242627;
    line-height: 16px;

}

.buy-margin-12 {
    margin-top: 12px;
}

.buy-duigong-text5 div {
    background: #CADCFF;
    border-radius: 5px 5px 5px 5px;
    padding: 4px 8px;
}

.buy-duigong-text6 {
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #E74B4B;
    line-height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/payment.vue